import { gptStore } from "@/store/gptStore";
import { isCustomDoc } from "@/ts/guards";
import type { SlotDiscoveryModule } from "@/ts/module";
import type { CustomDoc, DisplaySlotConfig, Exactly } from "@/ts/types";
export class SlotDiscovery implements Exactly<SlotDiscoveryModule, SlotDiscovery> {
    name = "SlotDiscovery" as const;
    async init(): Promise<void> {
        // nothing to do here
    }
    run(commandId: number, doc: CustomDoc): Promise<void> {
        const { actions } = gptStore.getState();
        if (isCustomDoc(doc)) {
            const adContainers = Array.from(doc.querySelectorAll('div[id^="div-gpt-ad-"]'));
            const slotConfigs = generateSlotConfig(adContainers);
            actions.setSlotConfigsByCommandId(commandId, slotConfigs);
        }
        return Promise.resolve();
    }
}
const getAdUnitPath = (element: Element) => {
    return element.getAttribute("data-ad-unit-path");
};
const getTargeting = (element: Element) => {
    const dataTargeting = element.getAttribute("data-targeting");
    if (dataTargeting) {
        return JSON.parse(dataTargeting);
    }
};
const generateSlotConfig = (adContainers: Element[]): DisplaySlotConfig[] => {
    const { slotsTemplate, pageAdUnitPath, usePageAdUnitPathForCarousel, slotSizes, } = gptStore.getState();
    const { targeting } = slotsTemplate;
    return adContainers.map((container) => {
        const slotId = container.id;
        const size = slotSizes[slotId];
        const containerAdUnitPath = getAdUnitPath(container);
        const containerTargeting = getTargeting(container);
        return {
            container,
            slotId,
            size,
            adUnitPath: containerAdUnitPath && !usePageAdUnitPathForCarousel
                ? containerAdUnitPath
                : pageAdUnitPath,
            targeting: {
                ...targeting,
                index: containerTargeting?.index.toString(),
                slotName: slotId,
            },
        };
    });
};
